import T from 'prop-types';

export const avatarPropType = T.shape({
  crop: T.shape({
    offset: T.shape({
      x: T.number,
      y: T.number,
    }),
  }),
  original: T.string,
  sizes: T.array,
});

export const featurePropType = T.shape({
  description: T.string,
  id: T.string,
  name: T.string,
});

export const featuresPropType = T.arrayOf(featurePropType);

export const groupPropType = T.shape({
  description: T.string,
  features: featuresPropType,
  id: T.string,
  name: T.string,
});

export const groupsPropType = T.arrayOf(groupPropType);

export const markerPropType = T.shape({
  body: T.shape({
    placement: T.oneOf(['preroll', 'midroll', 'postroll']),
    media: T.arrayOf(
      T.shape({
        url: T.string,
        type: T.string,
      })
    ),
  }),
  episode: T.string.isRequired,
  duration: T.number.isRequired,
  id: T.string.isRequired,
  start: T.number.isRequired,
  thumbnail: T.shape({
    original: T.string,
  }),
  type: T.oneOf(['Ad', 'Audio', 'Image', 'Link', 'Video']),
});

export const permissionPropType = T.shape({
  role: T.string,
  id: T.string,
  resource: T.string,
});

export const preferencePropType = T.shape({
  name: T.string,
  value: T.oneOfType([T.string, T.array, T.bool, T.object]),
});

export const preferencesPropType = T.arrayOf(preferencePropType);

export const permissionsPropType = T.arrayOf(permissionPropType);

export const profilePropType = T.shape({
  avatar: avatarPropType,
  user: T.string,
  global: T.object,
  groups: groupsPropType,
  messages: T.array,
  modified: T.string,
  created: T.string,
  id: T.string,
  preferences: preferencesPropType,
  permissions: permissionsPropType,
  name: T.string,
  email: T.string,
  roles: T.arrayOf(T.string),
});

export const rssPropType = T.shape({
  summary: T.string,
  subtitle: T.string,
  rating: T.string,
  author: T.string,
  ownerName: T.string,
  ownerEmail: T.string,
  managingEditor: T.string,
  lastImport: T.string,
  images: T.oneOfType([T.string, T.object, T.array]),
  imageTitle: T.string,
  explicit: T.string,
  categories: T.array,
});

export const showPropType = T.shape({
  rss: rssPropType,
  image: avatarPropType,
  name: T.string,
  permalinks: T.array,
  network: T.string,
  description: T.string,
  homepage: T.string,
  copyright: T.string,
  users: T.array,
  acasts: T.array,
  aggregate: T.array,
  categories: T.array,
  keywords: T.array,
  tags: T.array,
  rssUrl: T.string,
  rssAcastUrl: T.string,
  type: T.string,
  popularity: T.number,
  featured: T.bool,
  language: T.string,
  rating: T.string,
  exclusive: T.bool,
  hidden: T.bool,
  integrations: T.array,
  permissions: T.array,
  flags: T.array,
  owner: T.string,
  showType: T.string,
  midrollThreshold: T.number,
  publishDate: T.string,
  id: T.string,
  created: T.string,
  published: T.string,
  hosted: T.bool,
  modified: T.string,
});

export const showsPropType = T.shape({
  total: T.number,
  items: showPropType,
});

export const networkPayeePropType = T.shape({
  networkId: T.string,
  userId: T.string,
  created: T.string,
  modified: T.string,
  id: T.string,
  deleted: T.bool,
});

export const reactRouterLocationPropType = T.shape({
  hash: T.string,
  pathname: T.string,
  search: T.string,
});
